module.exports = __webpack_public_path__ + "img/aeroland-client-logo-12-hover.56f25d22.png";